module.exports = __webpack_public_path__ + "static/6-7c839d15a6f54e7025ba8c0c4b333e8f.woff";